import { Injectable } from '@jack-henry/frontend-utils/di';
import {
    AccountClient,
    UserInformationModelDto,
    UserModelDto,
    UserPasswordModelDto,
    UsersClient,
} from '@treasury/api/channel';
import { SessionStorageService } from '@treasury/utils';
import { CurrentUser } from '../user/current-user.entity';

@Injectable()
export class AccountService {
    constructor(
        private readonly accountClient: AccountClient,
        private readonly sessionStorage: SessionStorageService,
        private readonly usersClient: UsersClient
    ) {}

    public async getCurrentUser() {
        const response = await this.accountClient.accountGet({ maxAgeInSeconds: 60000 });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const companyId = this.sessionStorage.get<{ companyId: string }>('user')?.companyId || '';
        return new CurrentUser(response.data);
    }

    public async getPasswordRequirements(institution: string) {
        return this.accountClient.accountPasswordRequirements({
            fiId: institution,
        }) as unknown as Array<string>;
    }

    public async changePassword(body: UserPasswordModelDto) {
        return this.accountClient.accountChangePassword(body);
    }

    public async verifyUser(user: UserModelDto) {
        return this.accountClient.accountVerifyUserForPasswordReset(user);
    }

    public async createUser(body: UserInformationModelDto, id = 0) {
        return this.usersClient.usersSaveUserInformation(id, body);
    }

    public async searchUsers() {
        return this.usersClient.usersSearch({
            activeUsersOnly: false,
            enrolledUsersOnly: false,
            includeRoles: true,
        });
    }
}
